import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap"; 
import * as apiUrl from "../../apiUrl";

function CollectionAbout() {

  const [CollectionAbout, setCollectionAbout] = useState({});

  useEffect(() => {
    const fetchCollectionAbout = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/collection/about-section`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setCollectionAbout(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCollectionAbout();
  }, []);

  const descriptions = CollectionAbout.section_description
    ? JSON.parse(CollectionAbout.section_description)
    : [];

  return (
    <section className="collection-about-sec">
      <Container fluid>
        <Row className="flex-center">
          <Col md={6}>
            <div
              className="about-investing-content-div"
              data-aos="fade-right"
            >
              <h2 className="common-head goldenColor">
                {CollectionAbout.section_title}
              </h2>
              {descriptions.map((description, index) => (
                <p className="common-para" key={index}>
                  {descriptions[index]}
                </p>
              ))}
            </div>
          </Col>
          <Col md={6}>
            <img
              src={`${apiUrl.apiUrl}/${CollectionAbout.section_image}`}
              className="img-fluid"
              alt="Buy property in Dubai"
              data-aos="fade-left"
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default CollectionAbout;
